import Cropper from "react-easy-crop";
import { useState, useCallback } from "react";
import Slider from "@mui/material/Slider";
import getCroppedImg from "./cropImageUtils";

interface CropAvatarProps {
  imageSrc: string;
  onCropDone: (croppedFile: File) => void;
  onCancel: () => void;
}

export const CropAvatar = ({ imageSrc, onCropDone, onCancel }: CropAvatarProps) => {
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);

  const onCropComplete = useCallback((_: any, croppedPixels: any) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleDone = async () => {
    if (croppedAreaPixels) {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropDone(croppedImage);
    }
  };

  return (
    <div style={{ position: "relative", height: 400, background: "#333" }}>
      <Cropper
        image={imageSrc}
        crop={crop}
        zoom={zoom}
        aspect={1}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={onCropComplete}
      />
      <div style={{ position: "absolute", bottom: 20, left: 20, right: 20 }}>
        <Slider value={zoom} min={1} max={3} step={0.1} onChange={(_, z) => setZoom(z as number)} />
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
          <button onClick={handleDone}>Xong</button>
          <button onClick={onCancel}>Hủy</button>
        </div>
      </div>
    </div>
  );
};